import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

const baseURL = `${config.bocaAPIUrl}/testimonials`;

export default {
  getTestimonials: () => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', baseURL, { urlParams: { access_token: accessToken },
    });
  },
  createTestimonial: (data) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', baseURL, { data, urlParams: { access_token: accessToken } });
  },
  updateTestimonial: (id, newValue) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('PATCH', `${baseURL}/${id}`, { data: JSON.stringify(newValue), urlParams: { access_token: accessToken } });
  },
  deleteTestimonial: (id) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('DELETE', `${baseURL}/${id}`, { urlParams: { access_token: accessToken } });
  },
  uploadAvatar: (userId, formData) => {
    const {
      accessToken,
    } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/users/${userId}/photos`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/TestimonialAPIConnectors.js